export default "__VITE_ASSET__46f20ae1__"